<!--  I N T R O   -->
<app-request-an-insurance-quote
 mainHeading="QUOTE REQUEST"
 subHeading="false"
 ></app-request-an-insurance-quote>
<!-- //  I N T R O    -->


<!-- Start of form  -->
<section id="rtq-form" class="pb-5">
    <div class="container"> 
       <img  src="assets/img/PRELOADER.gif" class="preloader"  *ngIf="isLoading"/>
        <div class="row justify-content-center" *ngIf="!this.dataService.leadDetails.isServiceUnavailable">
            <div class="col-md-7 col-xs-12">                 
                <div class="form-div z-indexHeader text-center text-sm-center agent-info">
                    <div class="row pt-3">
                        <div class="col">
                            <p>Thank you!</p>
                            <p for="agentName">
                                Your agent is {{leadDetails.salesAgent.firstName + ' '
                                +leadDetails.salesAgent.lastName}}
                            </p>
                            <p for="phone">
                                Phone: {{leadDetails.salesAgent.phoneNumber}}
                            </p>
                            <p class="header-blue">CA License #: {{leadDetails.salesAgent.licenseNo}} </p>
                            <p class="header-blue">Resident State: {{leadDetails.salesAgent.residenceState}}</p>
                        </div>
                    </div>
                    <div class="row pt-3" *ngIf="leadDetails.salesAgent!=null && (leadDetails.salesAgent.salesAgentPhoto!='')">
                        <div class="col">
                            <img [src]="photoURL()" class="img-responsive img-width">
                        </div> 
                    </div>  
                    <div class="row pt-3">
                        <div class="col">
                            <p class="header-blue text-nowrap mobTextWrap">Please wait while we prepare your quote.</p>
                        </div>
                    </div> 
                    <div class="row pt-3">
                        <div class="col" *ngIf="this.dataService.leadDetails.isServiceUnavailable"> 
                            <p class="font-weight-bold header-blue mb-0 pb-0 text-sm-center p-2" [innerHTML]="dataService.leadDetails.errorMessage">
                            </p>    
                        </div>
                    </div>        
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End of form -->


